import type { TTranslationKeys } from '@config/i18n';
import ErrorCodes from '@conversed/shared/src/errors/error-codes';

export const ERROR_TRANSLATION_MAP: Record<string, TTranslationKeys> = {
  [ErrorCodes.INVALID_FILE_CONTENT]: 'errors.invalid-file-content',
  [ErrorCodes.INVALID_FILE_CONTENT_EMPTY]: 'errors.invalid-file-content-empty',
  [ErrorCodes.CONFLICT]: 'errors.conflict',
  [ErrorCodes.ALREADY_EXISTS]: 'errors.already-exists',
  [ErrorCodes.INVALID_REQUEST_BODY]: 'errors.invalid-request-body',
  [ErrorCodes.AUTHORIZATION_ERROR]: 'errors.authorization-error',
  [ErrorCodes.FORBIDDEN]: 'errors.forbidden',
  [ErrorCodes.UNKNOWN_ERROR]: 'errors.unknown-error',
  [ErrorCodes.INTERNAL_SERVER_ERROR]: 'errors.internal-server-error',
};

// * Returns the `error.codes.*` key of a backend error code when that code has a
// * translation. Returns null otherwise, so the caller can use its own fallback copy.
export const findErrorCodeKey = (
  errorCode: string | null | undefined,
  hasTranslation: (translationKey: string) => boolean,
): string | null => {
  if (!errorCode) {
    return null;
  }

  const codeKey = `error.codes.${errorCode}`;

  if (hasTranslation(codeKey)) {
    return codeKey;
  }

  return null;
};

const ARTICLE_ARCHITECT_ERROR_CODE_PREFIX = 'ARTICLE_ARCHITECT_';

// * Same lookup, limited to `ARTICLE_ARCHITECT_*` codes. A generic code such as
// * NOT_FOUND has translated copy too ("Not found!"), but it says less than the
// * caller's own fallback copy, so the caller gets null for it.
export const findArticleArchitectErrorCodeKey = (
  errorCode: string | null | undefined,
  hasTranslation: (translationKey: string) => boolean,
): string | null => {
  if (!errorCode?.startsWith(ARTICLE_ARCHITECT_ERROR_CODE_PREFIX)) {
    return null;
  }

  return findErrorCodeKey(errorCode, hasTranslation);
};

export const getErrorTranslationKey = (errorCode: string): string => {
  return ERROR_TRANSLATION_MAP[errorCode] || 'errors.unknown-error';
};
